/**
 * This file contains custom constant values that should be accessible everywhere in the app.
 */

// enum containing the major endpoint types used in the code
export enum DataProvider {
  Public,
  User,
  Venue,
}

export enum SeatingMapItemType {
  EVENT = "EVENT",
  MEMBERSHIP = "MEMBERSHIP",
}

// maximum amount of recurring events
// value is referenced by other maximum page size constants
export const MAX_RECURRING_EVENTS = 100;

// maximum page size for custom package options
export const MAX_CUSTOM_SUB_TICKET_OPTIONS = MAX_RECURRING_EVENTS;

// default max number of tickets able to be purchased is 8
export const DEFAULT_MAX_TICKET_PURCHASE_LIMIT = 8;

// default min number of tickets able to be purchased is 1
export const DEFAULT_MIN_TICKET_PURCHASE_LIMIT = 1;

// maximum ticket type selection on the box office is 3000
export const BOX_OFFICE_MAX_PURCHASE_QUANTITY = 3000;

// Showpass logo dimensions for consistent sizing across navigation components
export const LOGO_DIMENSIONS = {
  // Standard mobile logo size
  MOBILE_WIDTH: 125,
  // Standard desktop logo size
  DESKTOP_WIDTH: 135,
  // Standard height for all logo instances
  HEIGHT: 33,
  // Standard margin top for logo containers
  MARGIN_TOP: "1",
} as const;

// ID values that are accessed by document.getElementById() in multiple files
export const domElementIds = {
  navbarId: "navbar",
  navbarBannerId: "all-navbar-banners",
  seatingBannerId: "seating-banner",
  bestAvailableSeatingId: "best-available-seating-container",
  bestAvailableSeatingSelectSlideId: "best-available-seating-select-slide",
  headerDetailsId: "header-details",
  headerTabsId: "header-tabs",
  stickyHeaderId: "sticky-header",
  checkoutProgressBarId: "checkout-progress-bar",
};
